export default __webpack_public_path__ + "static/media/001-yin yang.fb927ed4.svg";